import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { Alert } from "@mui/material";
import type { IFormGenUiAlertSchema } from "node_modules/@artifact-management/json-dynamic-form/dist/types";
import type { FieldValues } from "react-hook-form";
import type { IFormGenComponentProps } from "../index";

export interface IFormGenAlertProps<Schema extends TJSONSchema, T extends FieldValues>
  extends IFormGenComponentProps<Schema, T> {
  uiSchemaElement: IFormGenUiAlertSchema<Schema>;
}

export const FormGenAlert = <Schema extends TJSONSchema, T extends FieldValues>({
  uiSchemaElement,
}: IFormGenAlertProps<Schema, T>) => {
  return <Alert severity={uiSchemaElement.severity}>{uiSchemaElement.message}</Alert>;
};
